import { NgModule, ModuleWithProviders, APP_INITIALIZER } from '@angular/core';
import { FeatureCanActivate } from './service/auth/feature.guard';
import { InterceptorModule } from './service/auth/httpinterceptor.module';
import { FeatureProvider } from './service/auth/feature.provider';
import { EcapHttp } from './service/http/EcapHttp';
import { TranslatePipeModule } from './service/translation/translate-pipe.module';
import { TranslateService } from './service/translation/TranslateService';
import { EcapTranslateService } from './service/translation/EcapTranslateService';
import { TokenProvider } from './service/token/token.provider';
import { AppProvider } from './service/auth/app.provider';
import { NavigationProvider } from './service/auth/navigation.provider';
import { EcapLoginService } from './service/auth/platform-login.service';
import { TokenState } from './service/token/token.state';
import { EcapCorporateIdentityService } from './service/utility/corporate-identity.Service';
import { PlatformDataService } from './service/pds/platform-data.service';
import { AggregateService } from './service/aggragate/aggregate.service';
import { SqlQueryBuilderService } from './service/query-builder/sql-query-builder.service';
import { StorageDataService } from "./service/storage/storage-data.service";
import { UserInfoService } from "./service/auth/user-info.service";
import { PagerService } from "./service/utility/pager.service";
import { PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ShellDomainProvider } from './service/utility/shell-domain.provider';
import { ScriptLoaderService } from './service/utility/script-loader.service';
import { NotificationService } from './service/notification/notification.service';
import { UtilityService } from './service/utility/utility.service';
import { EcapCoreUserAccessManagementService } from "./service/uam/user-access-management.service";
import { EcapCoreCalendarApiService } from './service/calendar-api/calendar-api.service';
import { EcapCorSendMailService } from './service/mail/send.email.service';
import { EcapCoreMixPanelService } from './service/mix-panel/mix-panel.service';
import { EcapCoreAnalyticsService } from './service/google-analytics/analytics.service'
import { Angulartics2Mixpanel, Angulartics2GoogleAnalytics } from 'angulartics2';
import { EcapCorSecurityPermissionUpdateService } from './service/security-permission/security-permission-update.service';
import { EcapCookieService } from './service/cookie/ecap-cookie.service';
import { EcapEsignatureService } from './service/esignature/esignature.service';

import { ClientMonitoringConfig, ClientMonitoringService } from './service/client-monitoring/client-monitoring.service';
import { ClientMonitoringErrorHandler } from './service/client-monitoring/client-monitoring-error.handler';
import { EcapTwoFactorService } from './service/two-factor/two-factor.service';
import { HotjarModule } from './service/hotjar/hotjar.module';
import { HotjarService } from './service/hotjar/hotjar.service';
import { SequenceNumberGeneratorService } from './service/sequence-number-generator/sequence-number-generator.service';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';

function isiOS(): any {
    var iDevices = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ];

    if (!!navigator.platform) {
        while (iDevices.length) {
            if (navigator.platform === iDevices.pop()) {
                return true;
            }
        }
    }

    return false;
}

function getParameterByName(name: string, url?: string) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function startupServiceFactory(
    http: HttpClient,
    plaformId: string, tokenProvider: TokenProvider,
    shellDomainProvider: ShellDomainProvider,
    userInfoService: UserInfoService,
    _cookieService: EcapCookieService) {
    return () => {
        console.log('[APP_INIT] startupServiceFactory called');
        console.log('[APP_INIT] isMock:', ShellDomainProvider['api']?.isMock);
        console.log('[APP_INIT] platformId:', plaformId);
        console.log('[APP_INIT] Token URL:', ShellDomainProvider['api']?.Token);
        if (ShellDomainProvider['api'].isMock) {
            console.log('[APP_INIT] isMock=true, skipping bootstrap');
        } else {
            return new Promise(function (resolve, reject) {
                if (plaformId === 'browser') {
                    const href = window.location.href;
                    console.log('[APP_INIT] href:', href);
                    if (href.indexOf('/auth?LogOff') > -1) {
                        console.log('[APP_INIT] LogOff detected, resolving');
                        resolve(true);
                    }
                    else {
                        if (isiOS()) {
                            let REFRESH_TOKEN = localStorage.getItem('REFRESH_TOKEN');
                            if (REFRESH_TOKEN) {
                                tokenProvider.setRefreshTokenToCookie(REFRESH_TOKEN);
                            }
                        }

                        let expectedCookie = '';
                        if (!getParameterByName('isAutoLogin')) {
                            expectedCookie = _cookieService.getCookie("REFRESH_TOKEN");
                        } else {
                            console.log("===========Clear Refresh Token because isAutoLogin enable on url========");
                        }
                        console.log('[APP_INIT] expectedCookie:', expectedCookie ? 'exists' : 'empty');

                        if (!expectedCookie) {
                            const body = new HttpParams().set('grant_type', 'authenticate_site');
                            const header = new HttpHeaders({
                                'Content-Type': 'application/x-www-form-urlencoded'
                            });
                            firstValueFrom(http.post(ShellDomainProvider['api'].Token,
                                body.toString(),
                                { headers: header, withCredentials: true, observe: 'response' }))
                                .then((response: any) => {
                                  let minutesToLive = 30*24*60; //dd*hh*mm==1 Month

                                  if(typeof ShellDomainProvider['api'].refreshTokenMinutesToLive === "number")
                                    minutesToLive = ShellDomainProvider['api'].refreshTokenMinutesToLive;

                                    const httpOnlyRefreshToken = ShellDomainProvider['api'].httpOnlyRefreshToken;
                                    const refreshToken = httpOnlyRefreshToken ? 'REFRESH_TOKEN' : response.body.refresh_token;
                                    _cookieService.eraseAndSetCookie('REFRESH_TOKEN', refreshToken, minutesToLive);

                                    userInfoService.setLoggedInUser();
                                    userInfoService.setTenantInfo();
                                    userInfoService.redirectToMasterSite(response.body);
                                    resolve(true);
                                }, (error: any) => {
                                    console.error('APP_INITIALIZER: anonymous token request failed', error);
                                    userInfoService.currentUserEvent.next({IsSuccess: false});
                                    resolve(true);
                                });
                        } else {

                            tokenProvider.refreshTokenObservable().subscribe({
                                next: (response: any) => {

                                  if (userInfoService.loggedOutRequired(response)) {
                                        userInfoService.loginSynchronizer();
                                        resolve(true);
                                    } else {
                                        userInfoService.setLoggedInUser();
                                        userInfoService.setTenantInfo();
                                        userInfoService.redirectToMasterSite(response);
                                        resolve(true);
                                    }

                                  },
                                error: (error: any) => {
                                    userInfoService.currentUserEvent.next({IsSuccess: false});
                                    resolve(true);
                                }
                            });
                        }
                    }
                } else {
                    // server bootstrap
                    if (process.env.REFRESH_TOKEN_FOR_IOS && process.env.ACCESS_TOKEN_FOR_IOS) {
                        process.env.ACCESS_TOKEN = process.env.ACCESS_TOKEN_FOR_IOS;
                        process.env.REFRESH_TOKEN = process.env.REFRESH_TOKEN_FOR_IOS;
                    }
                    if (process.env.ACCESS_TOKEN === 'undefined' || process.env.REFRESH_TOKEN === 'undefined') {
                        tokenProvider.setAccessToken(undefined);
                        tokenProvider.setRefreshToken(undefined);
                        const body = new HttpParams().set('grant_type', 'authenticate_site');
                        const header = new HttpHeaders({
                            'Content-Type': 'application/x-www-form-urlencoded'
                        });
                        firstValueFrom(http.post(ShellDomainProvider['api'].Token, body.toString(),
                            { headers: header, withCredentials: true, observe: 'response' }))
                            .then((response: any) => {
                                process.env.ACCESS_TOKEN = response.body.access_token;
                                process.env.REFRESH_TOKEN = response.body.refresh_token;
                                tokenProvider.setAccessToken(response.body.access_token);
                                tokenProvider.setRefreshToken(response.body.refresh_token);
                                userInfoService.setLoggedInUser();
                                userInfoService.setTenantInfo();
                                resolve(true);
                            }, (err: any) => {

                            });
                    } else {
                        tokenProvider.refreshTokenObservable().subscribe({
                            next: (response: any) => {
                                tokenProvider.setAccessToken(process.env.ACCESS_TOKEN);
                                tokenProvider.setRefreshToken(process.env.REFRESH_TOKEN);
                                userInfoService.setLoggedInUser();
                                userInfoService.setTenantInfo();
                                resolve(true);
                            },
                            error: (error: any) => {
                                tokenProvider.setAccessToken(process.env.ACCESS_TOKEN);
                                tokenProvider.setRefreshToken(process.env.REFRESH_TOKEN);
                                userInfoService.setLoggedInUser();
                                userInfoService.setTenantInfo();
                                resolve(true);
                            }
                        });
                    }
                }
            });
        }
    };
}
// @dynamic
@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [],
    exports: [
      InterceptorModule,
      TranslatePipeModule,
      HotjarModule
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: startupServiceFactory,
            deps: [HttpClient, PLATFORM_ID, TokenProvider, ShellDomainProvider, UserInfoService, EcapCookieService],
            multi: true
        }
    ]
})
export class EcapCoreModule {
    public static forRoot(config?: ClientMonitoringConfig): ModuleWithProviders<EcapCoreModule> {
      return {
            ngModule: EcapCoreModule,
            providers: [FeatureCanActivate, FeatureProvider, EcapHttp,
                EcapCoreUserAccessManagementService,
                TranslateService, TokenProvider, AppProvider,
                NavigationProvider, EcapLoginService, TokenState, EcapCorporateIdentityService,
                ShellDomainProvider, SqlQueryBuilderService, PlatformDataService, AggregateService,
                StorageDataService, UserInfoService, PagerService, ScriptLoaderService, NotificationService, UtilityService, EcapTranslateService,SequenceNumberGeneratorService,
                EcapCoreCalendarApiService, EcapCorSendMailService, EcapCoreMixPanelService, EcapEsignatureService, EcapTwoFactorService,
                EcapCorSecurityPermissionUpdateService, EcapCoreAnalyticsService, EcapCookieService, { provide: ClientMonitoringConfig, useValue: config },
                ClientMonitoringService, ClientMonitoringErrorHandler, HotjarService,
                Angulartics2Mixpanel, Angulartics2GoogleAnalytics]

        };
    }
}
